"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const react_helmet_1 = require("react-helmet");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const AppBar_1 = __importDefault(require("@mui/material/AppBar/AppBar"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const material_1 = require("@mui/material");
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const styles_1 = require("@mui/material/styles");
const categories_1 = require("companion-app-components/flux/categories");
const tags_1 = require("companion-app-components/flux/tags");
// COMPONENTS
const GraphWithRegister_1 = __importDefault(require("containers/NewReports/components/GraphWithRegister"));
const ItemizedTransactions_1 = __importDefault(require("containers/NewReports/components/ItemizedTransactions"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
// DATA & UTILS
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const types_1 = require("components/QFilterSelect/types");
const selectors_1 = require("data/payees/selectors");
const utils_1 = require("./utils");
const state_1 = require("./state");
const useStyles = (0, mui_1.makeStyles)()(({ palette, typography, mixins: { toolBar, appBar }, }) => ({
    chartSettingsContainer: {
        margin: 'auto',
    },
    graphContainer: {
        padding: 16,
    },
    root: {
        backgroundColor: palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        maxHeight: 'calc(100vh)',
        overflowY: 'scroll',
    },
    tab: {
        fontSize: 14,
        fontWeight: 500,
        minWidth: 0,
        padding: '6px 9px',
        whiteSpace: 'nowrap',
        '@media (min-width: 960px)': {
            padding: '6px 12px',
        },
        '@media (min-width: 1103px)': {
            padding: '6px 12px',
        },
    },
    titleContainer: {
        padding: '18px 0px 18px 32px',
        borderBottom: `1px solid ${palette.border.main}`,
    },
    tabsHeader: {
        boxShadow: 'none',
    },
    tabsFlexContainer: {
        justifyContent: 'flex-start',
        height: 48,
        alignItems: 'center',
        overflow: 'hidden',
        cursor: 'pointer',
        padding: '0 40px',
        '& > button': {
            maxWidth: 'none !important', // ie-11 needs this
        },
    },
    tabsIndicator: {
        height: 2,
        backgroundColor: palette.secondary.main,
        borderRadius: 2,
    },
    appBar,
    toolBar,
    toolBarContainer: {
        display: 'flex',
        margin: '0 auto',
        paddingLeft: 8,
        paddingRight: 8,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    headerTypography: Object.assign(Object.assign({}, typography.body2), { color: palette.text.secondary, fontWeight: 500, fontSize: 14 }),
    tabLabelContainer: {
        padding: '16px 24px',
        width: 'auto !important',
        fontSize: 18,
        letterSpacing: 'normal',
        color: `${palette.text.primary} !important`,
        minHeight: 'auto',
        textTransform: 'none',
        fontWeight: 500,
        opacity: 1,
        '&.Mui-selected': {
            color: `${palette.secondary.main} !important`,
            fontWeight: 500,
        },
    },
    tabWrapper: {
        flexDirection: 'row',
    },
    contentWrapper: {
        padding: '20px 40px',
    },
    tabsContainer: {
        backgroundColor: palette.background.paper,
        borderTop: 'none',
        borderBottom: `1px solid ${palette.border.strong}`,
        boxShadow: 'none',
    },
}));
const Reports = () => {
    var _a;
    const { classes } = useStyles();
    const theme = (0, styles_1.useTheme)();
    const isDesktopTabs = (0, useMediaQuery_1.default)(theme.breakpoints.up('md'));
    const navigate = (0, react_router_1.useNavigate)();
    const { tabName = 'spending', layoutView } = (0, react_router_1.useParams)();
    const tabValue = (0, utils_1.convertTabNameToValue)(tabName);
    const [globalState, dispatch] = (0, react_1.useReducer)(state_1.reduceReports, state_1.initialReportsState);
    const rootRef = (0, react_1.useRef)(null);
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const categoriesById = (0, react_redux_1.useSelector)(categories_1.categoriesSelectors.getAllCategoriesById);
    const tagsById = (0, react_redux_1.useSelector)(tags_1.tagsSelectors.getTags);
    const payeesNameList = (0, react_redux_1.useSelector)(selectors_1.getPayeesNameList);
    const handleTabClick = (0, react_1.useCallback)((_event, changeValue) => {
        const newTabName = (0, utils_1.convertTabValueToName)(changeValue);
        let route = `/reports/${newTabName}`;
        const changingGroupBy = (0, utils_1.getDefaultGroupByFromTabName)(newTabName);
        if (changingGroupBy) {
            route += `/by-${changingGroupBy}`;
        }
        const defaultIsOverTimeFromTabName = (0, utils_1.getDefaultIsOverTimeFromTabName)(newTabName);
        if (defaultIsOverTimeFromTabName != null) {
            const changingLayoutView = defaultIsOverTimeFromTabName ? 'over-time' : 'total';
            if (changingLayoutView) {
                route += `/${changingLayoutView}`;
            }
        }
        navigate(route);
        dispatch({ type: 'tabChange', payload: { tabName: newTabName } });
    }, [navigate]);
    const applyFilterToView = () => {
        var _a, _b, _c, _d, _e, _f, _g;
        const filterObject = (_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.reportsViewStates) === null || _a === void 0 ? void 0 : _a.filterObject;
        if (filterObject) {
            const availableCategories = (_c = (_b = filterObject.categories) === null || _b === void 0 ? void 0 : _b.filter) === null || _c === void 0 ? void 0 : _c.call(_b, (categoryId) => categoryId === 'UNCATEGORIZED' ||
                categoryId.startsWith('BALANCE_ADJUSTMENT_') ||
                Boolean(categoriesById.get(categoryId)));
            const availableTags = (_e = (_d = filterObject.tags) === null || _d === void 0 ? void 0 : _d.filter) === null || _e === void 0 ? void 0 : _e.call(_d, (tagId) => Boolean(tagsById.get(tagId)));
            const availablePayees = (_g = (_f = filterObject.payees) === null || _f === void 0 ? void 0 : _f.filter) === null || _g === void 0 ? void 0 : _g.call(_f, (payeeName) => { var _a; return (_a = payeesNameList === null || payeesNameList === void 0 ? void 0 : payeesNameList.find) === null || _a === void 0 ? void 0 : _a.call(payeesNameList, (payee) => { var _a; return ((_a = payee.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (payeeName === null || payeeName === void 0 ? void 0 : payeeName.toLowerCase()); }); });
            const { advanced } = filterObject;
            const hasFilters = (filterObject.accounts.size > 0 ||
                availableCategories.size > 0 ||
                availablePayees.size > 0 ||
                availableTags.size > 0 ||
                advanced.isBillOrSubscription !== undefined ||
                advanced.isExcludedFromReports !== undefined ||
                advanced.isReviewed !== undefined);
            const payload = {
                filterObject: hasFilters ? new types_1.FilterObject(Object.assign(Object.assign({}, filterObject), { advanced: new types_1.AdvancedFilterObject(advanced), categories: (0, immutable_1.Set)(availableCategories), payees: (0, immutable_1.Set)(availablePayees), tags: (0, immutable_1.Set)(availableTags), accounts: (0, immutable_1.Set)(filterObject.accounts), payeeNames: (0, immutable_1.Set)(filterObject.payeeNames) })) : null,
            };
            if (!hasFilters) {
                setDatasetPreference({ reportsViewStates: { filterObject: null } });
            }
            dispatch({ type: 'update', payload });
        }
    };
    (0, react_use_1.useEffectOnce)(() => {
        dispatch({ type: 'init', payload: { tabName, layoutView } });
        applyFilterToView();
    });
    (0, react_1.useEffect)(() => {
        applyFilterToView();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.reportsViewStates) === null || _a === void 0 ? void 0 : _a.filterObject]);
    const tabClasses = (0, react_1.useMemo)(() => ({
        wrapper: classes.tabWrapper,
        root: classes.tabLabelContainer,
    }), [classes.tabLabelContainer, classes.tabWrapper]);
    const stateContextValue = (0, react_1.useMemo)(() => ({ state: globalState, dispatch }), [globalState, dispatch]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop)
            rootRef.current.scrollTop = 0;
    }, [tabName]);
    (0, react_1.useLayoutEffect)(() => {
        if (globalState.tabName !== tabName) {
            dispatch({ type: 'tabChange', payload: { tabName } });
        }
    }, [globalState.tabName, tabName]);
    const isReportStateReady = globalState.pageInitialized && globalState.tabName === tabName;
    return (<state_1.ReportsStateContext.Provider value={stateContextValue}>
      <react_helmet_1.Helmet>
        <title>Reports</title>
      </react_helmet_1.Helmet>
      <AppBar_1.default className={classes.appBar} style={{ zIndex: 9 }}>
        <Toolbar_1.default className={classes.toolBar} id="spendingToolbar">
          {(<div className={classes.toolBarContainer}>
              <div>
                <material_1.Typography variant="h6" id="sot-top-left-header">
                  {(0, utils_1.convertTabNameToTitle)(tabName)}
                </material_1.Typography>
                {isReportStateReady && (<material_1.Typography variant="body2" id="date_range_label" className={classes.headerTypography}>
                    {`${globalState.dateRange.label}: ${globalState.dateRange.value.start.toFormat('MMM dd, yyyy')} – ${globalState.dateRange.value.end.toFormat('MMM dd, yyyy')}`}
                  </material_1.Typography>)}
              </div>
            </div>)}
        </Toolbar_1.default>
      </AppBar_1.default>
      <Paper_1.default elevation={0}>
        <AppBar_1.default position="static" color="default" className={classes.tabsContainer} elevation={0}>
          <Tabs_1.default value={tabValue} onChange={handleTabClick} variant={isDesktopTabs ? 'standard' : 'scrollable'} scrollButtons={isDesktopTabs ? false : 'auto'} textColor="primary" className={classes.tabsHeader} classes={{
            indicator: classes.tabsIndicator,
            flexContainer: classes.tabsFlexContainer,
        }}>
            <Tab_1.default label="Spending" id="spending-tab" classes={tabClasses}/>
            <Tab_1.default label="Net Income" id="income-tab" classes={tabClasses}/>
            <Tab_1.default label="Income vs. Expense" id="net-income-tab" classes={tabClasses}/>
            <Tab_1.default label="Itemized Transactions" id="itemized-tab" classes={tabClasses}/>
          </Tabs_1.default>
        </AppBar_1.default>
        {['spending',
            'income',
            'net-income',
            'savings',
            'net-worth'].includes(tabName) &&
            <>
          </>}
      </Paper_1.default>
      <div className={classes.contentWrapper}>
        <RendersCount_1.default id={'newReportsIndex'}/>
        {isReportStateReady &&
            (tabName === utils_1.Tabs.ITEMIZED_TRANSACTIONS ? <ItemizedTransactions_1.default /> : <GraphWithRegister_1.default />)}
      </div>
    </state_1.ReportsStateContext.Provider>);
};
exports.default = Reports;
